export default __webpack_public_path__ + "static/media/ipl_5.44cd6f18.png";